import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  public appConfig: any;
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  loadAppConfig() {
    return this.http
      .get(this.configPath()) // .get('/assets/config.json')
      .toPromise()
      .then((config) => {
        this.appConfig = config;
        console.log(this.appConfig.apiBaseUrl);
      });
  }

  configPath(): string {
    const urlWithoutProtocol = window.location.href.replace(/^https?:\/\//, '');
    // return '/assets/config/wuse.json';
    return '/assets/config/dev.json';
    if (urlWithoutProtocol.startsWith('owerri')) {
        return '/assets/config/owerri.json';
    } else if (urlWithoutProtocol.startsWith('wuse')) {
        return '/assets/config/wuse.json';
    } else if (urlWithoutProtocol.startsWith('lagos')) {
        return '/assets/config/lagos.json';
    } else if (urlWithoutProtocol.startsWith('kubwa')) {
        return '/assets/config/kubwa.json';
    } else if (urlWithoutProtocol.startsWith('staging')) {
      return '/assets/config/staging.json';
  }

    return '/assets/config.json';
  }

  get apiBaseUrl(): string {
    return this.appConfig.apiBaseUrl;
  }
}
